import { useEffect, useState } from "react";
import { MessageSquareReply, Send } from "lucide-react";
import { fmtDate } from "@/lib/api";

function AdviceReply({ onSend, testId }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      await onSend(text.trim());
      setText("");
    } catch (e) {} finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex gap-2">
      <input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} maxLength={4000}
        placeholder="Reply to this answer..." className="flex-1 min-w-0 rounded-lg border border-[#1A9AA8]/30 bg-white px-3 py-2 text-sm" data-testid={`${testId}-input`} />
      <button type="button" onClick={send} disabled={busy || !text.trim()} className="inline-flex items-center gap-1 rounded-lg bg-[#1A9AA8] text-white px-3 py-2 text-xs font-semibold disabled:opacity-50" data-testid={`${testId}-send`}>
        <Send className="h-3.5 w-3.5" /> Reply
      </button>
    </div>
  );
}

export function AnswerAdvice({ fieldId, comments, post, markRead, me }) {
  const section = `a:${fieldId}`;
  const items = comments.filter((c) => c.section === section);
  const unread = me === "student" && items.some((c) => !c.read_by_student);
  const [fresh, setFresh] = useState([]);
  const testId = `answer-advice-${fieldId}`;
  useEffect(() => {
    if (!unread || !markRead) return;
    setFresh((f) => [...f, ...items.filter((c) => !c.read_by_student).map((c) => c.id)]);
    markRead(section, me);
  }, [unread]); // eslint-disable-line react-hooks/exhaustive-deps
  if (me !== "host" && !items.length) return null;
  return (
    <div className="rounded-xl border-l-4 border-[#1A9AA8] bg-[#1A9AA8]/5 px-4 py-3 flex flex-col gap-2" data-testid={testId}>
      {items.map((c) => (
        <div key={c.id} className="text-sm" data-testid={`${testId}-item`}>
          <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-[#147C88]">
            <MessageSquareReply className="h-3.5 w-3.5" /> Mr. Greg's advice
            <span className="font-mono-ui normal-case tracking-normal font-normal text-slate-400">{fmtDate(c.created_at)}</span>
            {me === "student" && (fresh.includes(c.id) || !c.read_by_student) && <span className="rounded-full bg-[#F08A3C] text-white text-[10px] px-2 py-0.5 normal-case">new</span>}
          </p>
          <p className="mt-1 text-slate-700 whitespace-pre-wrap">{c.body}</p>
        </div>
      ))}
      {me === "host" && <AdviceReply onSend={(b) => post(section, b)} testId={testId} />}
    </div>
  );
}
